const SamlTokenFactory = function ($resource) {
    const standardSamlTokenParams = {
        individualId: "@individualId",
        groupId: "@groupId"
    };

    //var getComputerShareSamlTokenApi = '/computerShareSaml/individualId/:individualId/groupId/:groupId';
    const getComputerShareSamlTokenApi =
        "/participant-web-services/rest/sso/computerShareSaml/individualId/:individualId/groupId/:groupId";
    const getPrudentialSamlTokenApi =
        "/participant-web-services/rest/sso/prudentialSSO/indId/:individualId/group/:groupId";
    const getJPMorganSamlTokenApi =
        "/participant-web-services/rest/sso/jpmorganSSO/indId/:individualId/group/:groupId";
    const getCharltonSamlTokenApi =
        "/participant-web-services/rest/sso/charltonSSO/indId/:individualId/group/:groupId";
    const showTotalRewardsApi = "/participant-web-services/rest/accounts/hasCharltonPartService";
    const getMillimanSamlTokenApi =
        "/participant-web-services/rest/sso/millimanSSO/indId/:individualId/group/:groupId";
    const getDNPSamlTokenApi =
        "/participant-web-services/rest/sso/dnpSSO/indId/:individualId/group/:groupId";
    const getHewittSamlTokenApi =
        "/participant-web-services/rest/sso/ipAonHewittSSO/indId/:individualId/group/:groupId";
    const getBPSSamlTokenApi =
        "/participant-web-services/rest/sso/bpsSSO/indId/:individualId/group/:groupId";
    const getOptumSamlTokenApi =
        "/participant-web-services/rest/sso/optumSSO/indId/:individualId/group/:groupId";
    const getNewportSamlTokenApi =
        "/participant-web-services/rest/sso/newportSSO/indId/:individualId/group/:groupId";
    const getOctober3SamlTokenApi =
        "/participant-web-services/rest/sso/october3SSO/indId/:individualId/group/:groupId";
    const getOctober3OAGSamlTokenApi =
        "/participant-web-services/rest/sso/october3OAGSSO/indId/:individualId/group/:groupId";
    const getNewportAppleSamlTokenApi =
        "/participant-web-services/rest/sso/newportAppleSSO/indId/:individualId/group/:groupId";
    const getFindleySamlTokenApi =
        "/participant-web-services/rest/sso/findleySSO/indId/:individualId/group/:groupId";
    const getAonSamlTokenApi =
        "/participant-web-services/rest/sso/aonSSO/indId/:individualId/group/:groupId";
    const getCommonBondApi =
        "/participant-web-services/rest/sso/commonBondSSO/indId/:individualId/group/:groupId";
    const getCommonBondInstApi =
        "/participant-web-services/rest/sso/commonBondSSOInst/indId/:individualId/group/:groupId";
    const getRiteAidSamlTokenApi =
        "/participant-web-services/rest/sso/riteAidSSO/indId/:individualId/group/:groupId";
    const getTRSMillimanSamlTokenApi =
        "/participant-web-services/rest/sso/millimantrsSSO/indId/:individualId/group/:groupId";
    const getHSABankSamlTokenApi =
        "/participant-web-services/rest/sso/hsaBankSSO/indId/:individualId/group/:groupId";
    const getPershingSamlTokenApi =
        "/participant-web-services/rest/sso/pershingSSO/indId/:individualId/group/:groupId";
    const getAbbvieSamlTokenApi =
        "/participant-web-services/rest/sso/abbvieSSO/indId/:individualId/group/:groupId";
    const getEtradeSamlTokenApi =
        "/participant-web-services/rest/sso/etradeSSO/indId/:individualId/group/:groupId";
    const getMyDeferralSamlTokenApi =
        "/participant-web-services/rest/sso/myDeferralSSO/indId/:individualId/group/:groupId";
    const getThreeMSamlTokenApi =
        "/participant-web-services/rest/sso/threeMSSO/indId/:individualId/group/:groupId";
    const getMilliman2SamlTokenApi =
        "/participant-web-services/rest/sso/milliman2SSO/indId/:individualId/group/:groupId";
    const getCandidlySamlTokenApi =
        "/participant-web-services/rest/sso/candidlySSO/indId/:individualId/group/:groupId";
    const getBlueRidgeSamlTokenApi =
        "/participant-web-services/rest/sso/blueridgeSSO/indId/:individualId/group/:groupId";
    const getWellspanSamlTokenApi =
        "/participant-web-services/rest/sso/wellspanSSO/indId/:individualId/group/:groupId";
    const getOptumCycSamlTokenApi =
        "/participant-web-services/rest/sso/optumcycSSO/indId/:individualId/group/:groupId";
    const getPrudentialDBSamlTokenApi =
        "/participant-web-services/rest/sso/prudentialDBSSO/indId/:individualId/group/:groupId";
    const getWTWBAESamlTokenApi =
        "/participant-web-services/rest/sso/wtwbaeSSO/indId/:individualId/group/:groupId";
    const getTelusLifeworksSamlTokenApi =
        "/participant-web-services/rest/sso/telusSSO/indId/:individualId/group/:groupId";
    const getPhilipsComputerShareSamlTokenApi =
        "/participant-web-services/rest/sso/philipsSSO/indId/:individualId/group/:groupId";
    const getPhillipsToTelusSamlTokenApi =
        "/participant-web-services/rest/sso/phillipstotelusSSO/indId/:individualId/group/:groupId";
    const getBNYMellonSamlTokenApi =
        "/participant-web-services/rest/sso/bnymellonSSO/indId/:individualId/group/:groupId";
    const getVolvoToTelusSamlTokenApi =
        "/participant-web-services/rest/sso/volvoToTelusSSO/indId/:individualId/group/:groupId";
    const getComputerShareGracoSamlTokenApi =
        "/participant-web-services/rest/sso/computerShareGracoSaml/individualId/:individualId/groupId/:groupId";

    return {
        //This gets the ComputerShare Saml Token and URL to post for a SSO.
        getComputerShareSamlToken: $resource(
            __baseApiUrl__ + getComputerShareSamlTokenApi,
            standardSamlTokenParams,
            {
                query: {
                    method: "GET",
                    isArray: false
                }
            }
        ),
        getPrudentialSamlToken: $resource(
            __baseApiUrl__ + getPrudentialSamlTokenApi,
            standardSamlTokenParams,
            {
                query: {
                    method: "GET",
                    isArray: false
                }
            }
        ),
        getCharltonSamlToken: $resource(
            __baseApiUrl__ + getCharltonSamlTokenApi,
            standardSamlTokenParams,
            {
                query: {
                    method: "GET",
                    isArray: false
                }
            }
        ),
        showTotalRewards: $resource(
            __baseApiUrl__ + showTotalRewardsApi,
            {},
            {
                query: {
                    method: "GET",
                    isArray: false
                }
            }
        ),
        getJPMorganSamlToken: $resource(
            __baseApiUrl__ + getJPMorganSamlTokenApi,
            standardSamlTokenParams,
            {
                query: {
                    method: "GET",
                    isArray: false
                }
            }
        ),
        getMillimanSamlToken: $resource(
            __baseApiUrl__ + getMillimanSamlTokenApi,
            standardSamlTokenParams,
            {
                query: {
                    method: "GET",
                    isArray: false
                }
            }
        ),
        getDNPSamlToken: $resource(__baseApiUrl__ + getDNPSamlTokenApi, standardSamlTokenParams, {
            query: {
                method: "GET",
                isArray: false
            }
        }),
        getHewittSamlToken: $resource(
            __baseApiUrl__ + getHewittSamlTokenApi,
            standardSamlTokenParams,
            {
                query: {
                    method: "GET",
                    isArray: false
                }
            }
        ),
        getBPSSamlToken: $resource(__baseApiUrl__ + getBPSSamlTokenApi, standardSamlTokenParams, {
            query: {
                method: "GET",
                isArray: false
            }
        }),
        getOptumSamlToken: $resource(
            __baseApiUrl__ + getOptumSamlTokenApi,
            standardSamlTokenParams,
            {
                query: {
                    method: "GET",
                    isArray: false
                }
            }
        ),
        getNewportSamlToken: $resource(
            __baseApiUrl__ + getNewportSamlTokenApi,
            standardSamlTokenParams,
            {
                query: {
                    method: "GET",
                    isArray: false
                }
            }
        ),
        getOctober3SamlToken: $resource(
            __baseApiUrl__ + getOctober3SamlTokenApi,
            standardSamlTokenParams,
            {
                query: {
                    method: "GET",
                    isArray: false
                }
            }
        ),
        getNewportAppleSamlToken: $resource(
            __baseApiUrl__ + getNewportAppleSamlTokenApi,
            standardSamlTokenParams,
            {
                query: {
                    method: "GET",
                    isArray: false
                }
            }
        ),
        getFindleySamlToken: $resource(
            __baseApiUrl__ + getFindleySamlTokenApi,
            standardSamlTokenParams,
            {
                query: {
                    method: "GET",
                    isArray: false
                }
            }
        ),
        getAonSamlToken: $resource(__baseApiUrl__ + getAonSamlTokenApi, standardSamlTokenParams, {
            query: {
                method: "GET",
                isArray: false
            }
        }),
        getCBNSamlToken: $resource(__baseApiUrl__ + getCommonBondApi, standardSamlTokenParams, {
            query: {
                method: "GET",
                isArray: false
            }
        }),
        getCBNInstSamlToken: $resource(
            __baseApiUrl__ + getCommonBondInstApi,
            standardSamlTokenParams,
            {
                query: {
                    method: "GET",
                    isArray: false
                }
            }
        ),
        getRiteAidSamlToken: $resource(
            __baseApiUrl__ + getRiteAidSamlTokenApi,
            standardSamlTokenParams,
            {
                query: {
                    method: "GET",
                    isArray: false
                }
            }
        ),
        getTRSMillimanSamlToken: $resource(
            __baseApiUrl__ + getTRSMillimanSamlTokenApi,
            standardSamlTokenParams,
            {
                query: {
                    method: "GET",
                    isArray: false
                }
            }
        ),
        getHSABankSamlToken: $resource(
            __baseApiUrl__ + getHSABankSamlTokenApi,
            standardSamlTokenParams,
            {
                query: {
                    method: "GET",
                    isArray: false
                }
            }
        ),
        getPershingSamlToken: $resource(
            __baseApiUrl__ + getPershingSamlTokenApi,
            standardSamlTokenParams,
            {
                query: {
                    method: "GET",
                    isArray: false
                }
            }
        ),
        getAbbvieSamlToken: $resource(
            __baseApiUrl__ + getAbbvieSamlTokenApi,
            standardSamlTokenParams,
            {
                query: {
                    method: "GET",
                    isArray: false
                }
            }
        ),
        getEtradeSamlToken: $resource(
            __baseApiUrl__ + getEtradeSamlTokenApi,
            standardSamlTokenParams,
            {
                query: {
                    method: "GET",
                    isArray: false
                }
            }
        ),
        getMyDeferralSamlToken: $resource(
            __baseApiUrl__ + getMyDeferralSamlTokenApi,
            standardSamlTokenParams,
            {
                query: {
                    method: "GET",
                    isArray: false
                }
            }
        ),
        getThreeMSamlToken: $resource(
            __baseApiUrl__ + getThreeMSamlTokenApi,
            standardSamlTokenParams,
            {
                query: {
                    method: "GET",
                    isArray: false
                }
            }
        ),
        getMilliman2SamlToken: $resource(
            __baseApiUrl__ + getMilliman2SamlTokenApi,
            standardSamlTokenParams,
            {
                query: {
                    method: "GET",
                    isArray: false
                }
            }
        ),

        getOctober3OAGSamlToken: $resource(
            __baseApiUrl__ + getOctober3OAGSamlTokenApi,
            standardSamlTokenParams,
            {
                query: {
                    method: "GET",
                    isArray: false
                }
            }
        ),

        getCandidlySamlToken: $resource(
            __baseApiUrl__ + getCandidlySamlTokenApi,
            standardSamlTokenParams,
            {
                query: {
                    method: "GET",
                    isArray: false
                }
            }
        ),
        getBlueRidgeSamlToken: $resource(
            __baseApiUrl__ + getBlueRidgeSamlTokenApi,
            standardSamlTokenParams,
            {
                query: {
                    method: "GET",
                    isArray: false
                }
            }
        ),
        getWellspanSamlToken: $resource(
            __baseApiUrl__ + getWellspanSamlTokenApi,
            standardSamlTokenParams,
            {
                query: {
                    method: "GET",
                    isArray: false
                }
            }
        ),
        getOptumCycSamlToken: $resource(
            __baseApiUrl__ + getOptumCycSamlTokenApi,
            standardSamlTokenParams,
            {
                query: {
                    method: "GET",
                    isArray: false
                }
            }
        ),
        getPrudentialDBSamlToken: $resource(
            __baseApiUrl__ + getPrudentialDBSamlTokenApi,
            standardSamlTokenParams,
            {
                query: {
                    method: "GET",
                    isArray: false
                }
            }
        ),
        getWTWBAESamlToken: $resource(
            __baseApiUrl__ + getWTWBAESamlTokenApi,
            standardSamlTokenParams,
            {
                query: {
                    method: "GET",
                    isArray: false
                }
            }
        ),
        getTelusLifeworksSamlToken: $resource(
            __baseApiUrl__ + getTelusLifeworksSamlTokenApi,
            standardSamlTokenParams,
            {
                query: {
                    method: "GET",
                    isArray: false
                }
            }
        ),
        getPhilipsComputerShareSamlToken: $resource(
            __baseApiUrl__ + getPhilipsComputerShareSamlTokenApi,
            standardSamlTokenParams,
            {
                query: {
                    method: "GET",
                    isArray: false
                }
            }
        ),
        getPhillipsToTelusSamlToken: $resource(
            __baseApiUrl__ + getPhillipsToTelusSamlTokenApi,
            standardSamlTokenParams,
            {
                query: {
                    method: "GET",
                    isArray: false
                }
            }
        ),
        getBNYMellonSamlToken: $resource(
            __baseApiUrl__ + getBNYMellonSamlTokenApi,
            standardSamlTokenParams,
            {
                query: {
                    method: "GET",
                    isArray: false
                }
            }
        ),
        getVolvoToTelusSamlToken: $resource(
            __baseApiUrl__ + getVolvoToTelusSamlTokenApi,
            standardSamlTokenParams,
            {
                query: {
                    method: "GET",
                    isArray: false
                }
            }
        ),
        getComputerShareGracoSamlToken: $resource(
            __baseApiUrl__ + getComputerShareGracoSamlTokenApi,
            standardSamlTokenParams,
            {
                query: {
                    method: "GET",
                    isArray: false
                }
            }
        )
    };
};

SamlTokenFactory.$inject = ["$resource"];
export default SamlTokenFactory;
